import React from "react";
import {useRouteMatch, Route} from 'react-router-dom';
import LandingCustomer from "../views/customer/LandingCustomer/LandingCustomer";
import {compose} from 'recompose';
import {withAffinityContextProvider, withAffinityContextReady} from "../context/AffinityContext";
import ProductsCustomer from "../views/customer/ProductsCustomer/ProductsCustomer";
import CustomerCotizarPage from "../components/Formularios/CustomerCotizar/VehiculoForm/CustomerCotizarPage";
import CustomerCotizarCombinado from "../components/Formularios/CustomerCotizar/CombinadoForm/CustomerCotizarPage";
import CustomerCotizarMotovehiculo from "../components/Formularios/CustomerCotizar/MotovehiculoForm/CustomerCotizarPage";
import CustomerCotizarOtros from "../components/Formularios/CustomerCotizar/OtrosForm/CustomerCotizarPage";
import CustomerCotizarPrevencion from "../components/Formularios/CustomerCotizar/PrevencionForm/CustomerCotizarPage";
import CustomerCotizarMicroseguro from "../components/Formularios/CustomerCotizar/MicrosegurosForm/CustomerCotizarPage";
import EndingCustomer from "../views/customer/LandingCustomer/EndingCustomer";


const AffinityRoutes = () => {
    const {path} = useRouteMatch();

    return (
        <>
            <Route exact path={`${path}/landing`} component={LandingCustomer}/>
            <Route path={`${path}/productos`} component={ProductsCustomer}/>
            <Route path={`${path}/cotizar/vehiculo`} component={CustomerCotizarPage}/>
            <Route path={`${path}/cotizar/motovehiculo`} component={CustomerCotizarMotovehiculo}/>
            <Route path={`${path}/cotizar/combinado`} component={CustomerCotizarCombinado}/>
            <Route path={`${path}/cotizar/otros`} component={CustomerCotizarOtros}/>
            <Route path={`${path}/cotizar/microseguro`} component={CustomerCotizarMicroseguro}/>
            <Route path={`${path}/cotizar/prevencion`} component={CustomerCotizarPrevencion}/>
            <Route path={`${path}/end`} component={EndingCustomer}/>
        </>

    );
};

export default compose(
    withAffinityContextProvider,
    withAffinityContextReady
)(AffinityRoutes);